export const headerData = {
    name: 'Mavin Sandeep',
    title: 'Embedded Systems Engineer',
    desciption: 'I build production-ready IoT products and intelligent software systems by combining firmware, hardware design, cloud APIs, and modern app experiences.',
    image: 'https://i.ibb.co/6JpXhfts/IMG-20250407-173025476-MF-PORTRAIT-1.jpg',
    imagebw: 'https://i.ibb.co/6JpXhfts/IMG-20250407-173025476-MF-PORTRAIT-1.jpg',
    resumePdf: '/resume'
}
